import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { ATCONSTANTS as ATC } from 'appconstants';
import { getToken } from '@ctsu/loader';

function TrackingCodeStatus({
  data, showTrackingCode, columns, id
}) {
  const getFollowUpCount = (accumulator, currentValue) => {
    if (currentValue.followupReason !== null) {
      // eslint-disable-next-line no-param-reassign
      accumulator++;
    }
    return accumulator;
  };
  return (
    <>
      {showTrackingCode ? (
        <span className="content-group-title">
          Tracking Code Status:
          {' '}
          <span data-id={`${ATC.PACKETID}${id}_TRACKING_CODE_STATUS${ATC.LABEL}`}>
            {data != null && data.length > 0 ? data[0].trackingCodeStatus : null}
          </span>
        </span>
      ) : null}
      <div className="mt-3">
        <GridTable tag={`${ATC.PACKETID}TRACKING_CODE_BROWSER${ATC.TABLE}`} columns={columns} rows={data} toPdf={false} getToken={getToken} />
      </div>
      {!showTrackingCode ? (
        <span className="mr-2 float-right">
          # of follow-ups:
          {' '}
          <span>{data.reduce(getFollowUpCount, 0)}</span>
        </span>
      ) : null}
    </>
  );
}

export default TrackingCodeStatus;
